import { render, staticRenderFns } from "./entrance-guard-dialog.vue?vue&type=template&id=6dd3401c&scoped=true"
import script from "./entrance-guard-dialog.vue?vue&type=script&lang=js"
export * from "./entrance-guard-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3401c",
  null
  
)

export default component.exports